import { AppErrorScreen } from '@components/AppErrorScreen';
import { AuthProvider } from '@contexts/Auth';
import { ProfileProvider } from '@contexts/BankProfileContext';
import { CCFeatureFlagContextProvider } from '@contexts/CCFeatureFlagContext';
import { type ErrorItem, ErrorProvider } from '@contexts/ErrorContext';
import { FeatureProvider } from '@contexts/FeatureContext';
import { GeoDataProvider } from '@contexts/GeoDataContext';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';

import { ErrorBoundary } from '../ErrorBoundary';
import { queryClient } from '../services/queryClient';
import { router } from './routes';

export const globalErrors: ErrorItem[] = [];

export const App = () => (
	<ErrorBoundary fallback={<AppErrorScreen />}>
		<AuthProvider>
			<QueryClientProvider client={queryClient}>
				<GeoDataProvider>
					<ProfileProvider>
						<FeatureProvider>
							<CCFeatureFlagContextProvider>
								<ErrorProvider initialErrors={globalErrors}>
									<RouterProvider router={router} />
									<Toaster
										closeButton
										duration={2000}
										mobileOffset={32}
										offset={32}
										position="bottom-center"
									/>
								</ErrorProvider>
							</CCFeatureFlagContextProvider>
						</FeatureProvider>
					</ProfileProvider>
				</GeoDataProvider>
			</QueryClientProvider>
		</AuthProvider>
	</ErrorBoundary>
);
